import { Fragment } from "react";
import { IconButton, TextField } from "@mui/material";
import PropTypes from "prop-types";
import { AutoFixHigh } from "@mui/icons-material";
import { convertToDefEventPara } from "../helper.js";
import { textFieldDefaults } from "../formControlDefaults.js";

Input.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
  evaluateExpression: PropTypes.func,
};

export default function Input(props) {
  const {
    item,
    value = false,
    error = null,
    onChange,
    showErrorText = false,
    disabled = false,
    evaluateExpression,
  } = props;

  let inputValue = value;
  if (!value) inputValue = "";

  let helperText = "";
  if (showErrorText) helperText = error;

  const fillHelper = () => {
    onChange(
      convertToDefEventPara(
        item.name,
        evaluateExpression(item.fill_helper).result
      )
    );
  };

  return (
    <Fragment>
      <TextField
        {...textFieldDefaults}
        label={item.label}
        name={item.name}
        value={inputValue}
        onChange={onChange}
        disabled={disabled}
        {...(error && { error: true, helperText: helperText })}
        slotProps={{
          input: item.fill_helper && {
            endAdornment: (
              <IconButton
                disabled={disabled}
                onClick={() => fillHelper()}
                edge="end"
              >
                <AutoFixHigh />
              </IconButton>
            ),
          },
        }}
      />
    </Fragment>
  );
}
